import React from 'react'


interface Props {
  className?: string,
}


const NavbarMenuSvg: React.FC<Props> = (props) => {
  return (
    <>
      {/* Theme: Light */}
      <span className="dark:hidden">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}>
          <path d="M10.435 18.783a5.217 5.217 0 10-10.435 0 5.217 5.217 0 0010.435 0zM10.435 5.217A5.217 5.217 0 100 5.217a5.217 5.217 0 0010.435 0z" fill="#FF5B21" />
          <path d="M24 18.783a5.217 5.217 0 10-10.435 0 5.217 5.217 0 0010.435 0zM24 5.217a5.217 5.217 0 10-10.435 0 5.217 5.217 0 0010.435 0z" fill="#041A38" />
        </svg>
      </span>
      {/* Theme: Dark */}
      <span className="hidden dark:block">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}>
          <path d="M10.435 18.783a5.217 5.217 0 10-10.435 0 5.217 5.217 0 0010.435 0zM10.435 5.217A5.217 5.217 0 100 5.217a5.217 5.217 0 0010.435 0z" fill="#FF5B21" />
          <path d="M24 18.783a5.217 5.217 0 10-10.435 0 5.217 5.217 0 0010.435 0zM24 5.217a5.217 5.217 0 10-10.435 0 5.217 5.217 0 0010.435 0z" fill="#FFFFFF" />
        </svg>
      </span>
    </>
  )
}


NavbarMenuSvg.defaultProps = {
  className: 'w-8 h-8'
}


export default NavbarMenuSvg;